import { auth } from "./auth"
import { layout } from "./layout"
import { navbar } from "./navbar"
import { stuffs } from "./stuffs"
import { modals } from "./modals"
import { companies } from "./companies"
import { categories } from "./categories"
import { owners } from "./owners"
import { auctions } from "./auctions"
import { analytics } from "./analytics"
import { customers } from "./customers"
import { bidding } from "./bidding"
import { notifications } from "./notifications"
import { directSale } from "./direct-sale"
import { refunds } from "./refunds"
import { exhibitions } from "./exhibitions"
import { realestate } from "./realestate"
import { souq } from "./souq"
import {showRooms} from "./showRooms"
import {showRoomsItems} from "./showRoomsItems"
import {prefs} from "./prefs"

export default {
  auth,
  customers,
  refunds,
  bidding,
  analytics,
  owners,
  notifications,
  auctions,
  layout,
  categories,
  directSale,
  navbar,
  stuffs,
  modals,
  exhibitions,
  prefs,
  showRoomsItems,
  realestate,
  companies,
  showRooms,
  souq
}
